import { trpc } from 'api'
import usePayments from './usePayments'

interface Options {
  onSuccess?: () => void | Promise<void>
  onError?: NonNullable<
    Parameters<typeof trpc.order.submit.useMutation>[0]
  >['onError']
}

/**
 * Call on submit with a guard to avoid submitting the same orders multiple times
 */
export default function useOrderSubmit({ onSuccess, onError }: Options = {}) {
  const submittedOrderIds = usePayments((s) => s.submittedOrderIds)
  const markOrdersSubmitted = usePayments((s) => s.markOrdersSubmitted)

  const mutation = trpc.order.submit.useMutation({
    onSuccess: async (_, variables) => {
      markOrdersSubmitted(variables.order_ids)
      await onSuccess?.()
    },
    onError,
  })

  const mutate = (orderIds: number[]) => {
    const pending = orderIds.filter((id) => !submittedOrderIds[id])
    if (pending.length === 0) {
      void onSuccess?.()
      return
    }
    mutation.mutate({ order_ids: pending })
  }

  return {
    mutate,
    isPending: mutation.isPending,
    reset: mutation.reset,
  }
}
